import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * ErrorState — the request failed. Always offer a way out (retry) when the caller
 * can retry; a dead end with no action is what pages did before (see UI_STANDARDS §1.6).
 */
const ErrorState = ({ title = 'Something went wrong', message, onRetry, retryLabel = 'Retry', sx = {} }) => (
    <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ py: 6, px: 2, textAlign: 'center', ...sx }}>
        <ErrorOutlineIcon sx={{ fontSize: 44, color: 'error.main' }} />
        <Typography variant="subtitle1" fontWeight={600}>
            {title}
        </Typography>
        {message && (
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                {message}
            </Typography>
        )}
        {onRetry && (
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRetry} sx={{ mt: 1 }}>
                {retryLabel}
            </Button>
        )}
    </Stack>
);

export default ErrorState;
